"use client";
import React, { FC, ReactNode, useState } from "react";

type inputType = {
  handleRangeChange: (e: any) => void;
  rangeValue: any;
};

const InputRange: FC<inputType> = ({ rangeValue, handleRangeChange }) => {
  return (
    <>
      <div className="flex items-center justify-center mb-6 mt-5">
        <input
          type="range"
          min="50"
          max="500"
          value={rangeValue}
          onChange={handleRangeChange}
          list="markers"
          step="150"
        />
        <datalist id="markers">
          <option value="0"></option>
          <option value="25"></option>
          <option value="50"></option>
          <option value="75"></option>
          <option value="100"></option>
        </datalist>
      </div>
    </>
  );
};

export default InputRange;
